// extracted by mini-css-extract-plugin
export default {"inputContainer":"e52d8824","messageInput":"cbf97121","antInput":"c627d2ac","sendButton":"f5a41fdd"};